export default __webpack_public_path__ + "static/media/glyphs-no-3.466d9c9c.mid";